export default "__VITE_ASSET__PoG$N7Ao__"